export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15214.d89b6d12.jpg";